import { Col, DatePicker, Row } from "antd";
import { GlobalContext } from "contexts/GlobalContext";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { storeInLocalStorage } from "helpers/Pricer/Table";
import moment from "moment";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function YourMarksCalcDate({
  setDateTime,
  dateTime,
  setSelectedFilters,
  disabledCondition,
}) {
  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);
  const location = useLocation();
  const { canChangeMarksCalcDate } = useVolSurfaceControlTable();

  const pathName = location.pathname;
  const isVolSurfacePage = pathName.includes("vol-surface");
  const hideDateFilterOnProdForVolSurface = !isVolSurfacePage;

  const handleRangePickerChange = (dateStr) => {
    setDateTime(dateStr ? moment(dateStr).format("YYYY-MM-DD HH:mm:ss") : "");
    storeInLocalStorage("IsMarksCalcDateChanged", JSON.stringify(true));
  };

  const dateValue = () => {
    if (dateTime) {
      return moment(dateTime);
    } else {
      return "";
    }
  };

  useEffect(() => {
    storeInLocalStorage("IsMarksCalcDateChanged", JSON.stringify(false));

    return () => {
      storeInLocalStorage("IsMarksCalcDateChanged", JSON.stringify(false));
    };
  }, []);
  return (
    <>
      <Col style={{ width: "100%" }} span={24}>
        {!hideDateFilterOnProdForVolSurface && (
          <Row
            style={{ width: "100%" }}
            size={"middle"}
            className={`${dark_Theme && "date-picker-dark"}`}
          >
            <Col span={3}>
              <span style={{ whiteSpace: "nowrap" }}>Calculation Date:</span>
            </Col>
            <Col>
              <DatePicker
                disabled={!canChangeMarksCalcDate || disabledCondition}
                onChange={handleRangePickerChange}
                className={
                  dateTime &&
                  !moment(dateTime)?.isSame(moment(), "day") &&
                  "filled--data_rangePicker__background"
                }
                popupClassName={dark_Theme && "date-picker-dropdown-dark"}
                value={dateValue()}
                showTime
              />
            </Col>
          </Row>
        )}
      </Col>
    </>
  );
}
